var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.621,
    height: 47,
    viewBox: "0 0 70.621 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4234",
    "data-name": "Group 4234",
    transform: "translate(430 -5779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4143",
    "data-name": "Group 4143",
    transform: "translate(-393.111 5779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10709",
    "data-name": "Path 10709",
    d: "M954.993,517.207H962.9a2.669,2.669,0,0,1-2.669,2.67h-.955v11.009h0a3.332,3.332,0,0,1-3.332-3.332v-7.677h-3.624A2.67,2.67,0,0,1,954.993,517.207Z",
    transform: "translate(-952.324 -517.207)",
    fill: "#fe6289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10710",
    "data-name": "Path 10710",
    d: "M1002.549,517.871h0v4.693a3.757,3.757,0,0,1,3.141-1.479c2.319,0,3.871,1.607,3.871,4.346v5.953h0a3.1,3.1,0,0,1-3.1-3.1v-2.429a1.963,1.963,0,1,0-3.908,0v2.41a3.122,3.122,0,0,1-3.122,3.122h0v-10.39A3.122,3.122,0,0,1,1002.549,517.871Z",
    transform: "translate(-987.608 -517.704)",
    fill: "#fe6289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10711",
    "data-name": "Path 10711",
    d: "M1056.235,535.612a4.8,4.8,0,0,0-5.077-5.077,5.242,5.242,0,0,0,0,10.482,4.826,4.826,0,0,0,4.608-2.835.494.494,0,0,0-.452-.689h-2.352a.5.5,0,0,0-.417.234,1.664,1.664,0,0,1-1.5.752,1.8,1.8,0,0,1-1.818-1.326.491.491,0,0,1,.474-.628h6.024a.493.493,0,0,0,.492-.463C1056.23,535.908,1056.235,535.758,1056.235,535.612Zm-6.438-.822a.491.491,0,0,1-.446-.7,1.886,1.886,0,0,1,1.771-1.049,1.842,1.842,0,0,1,1.795,1.082.493.493,0,0,1-.46.671Z",
    transform: "translate(-1022.503 -527.191)",
    fill: "#fe6289"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10712",
    "data-name": "Path 10712",
    d: "M830.17,556.9c-2.429-1.72-5.113-1.687-7.889-1.155a2.889,2.889,0,0,1,2.764-1.939,7.923,7.923,0,0,1,7.1,2.949,14.03,14.03,0,0,1,1.927,3.339c-2.082-1.125-4.162-.749-6.267-.488-1.87.232-3.767.384-5.233-1.294-.206-.236-.936-.192-1.343-.049a8.873,8.873,0,0,0-4.678,12.61c1.982,3.722,5.261,5.44,9.383,5.707.285.018.573,0,.86.034a11,11,0,0,1-12.363-7.588c-1.645-5.434,2.228-11.442,8.012-12.478a13.689,13.689,0,0,1,7.276.323A1.617,1.617,0,0,0,830.17,556.9Z",
    transform: "translate(-1241.856 5234.415)",
    fill: "#91c788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10713",
    "data-name": "Path 10713",
    d: "M812.891,586.558a10.253,10.253,0,0,1-7.583-9.66c-.124-4.568,2.434-8.639,6.185-9.585a10.55,10.55,0,0,0-4.622,9.979A11.1,11.1,0,0,0,812.891,586.558Z",
    transform: "translate(-1235.304 5224.258)",
    fill: "#91c788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10714",
    "data-name": "Path 10714",
    d: "M825.8,543.98l-3.4-3.782-.329.265L825,544.386a3.082,3.082,0,0,1-3.956-2.2c-.369-1.046-.77-2.081-1.152-3.109A4.6,4.6,0,0,1,825.8,543.98Z",
    transform: "translate(-1246.231 5245.535)",
    fill: "#91c788"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2176",
    "data-name": "Group 2176",
    transform: "translate(-423.451 5793.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9244",
    "data-name": "Path 9244",
    d: "M832.152,585.933a5.378,5.378,0,0,1,2.115-2.176,6.279,6.279,0,0,1,3.152-.778,5.977,5.977,0,0,1,3.8,1.206,5.479,5.479,0,0,1,1.989,3.282H839.6a2.347,2.347,0,0,0-2.229-1.405,2.3,2.3,0,0,0-1.859.832,3.337,3.337,0,0,0-.693,2.217,3.378,3.378,0,0,0,.693,2.236,2.3,2.3,0,0,0,1.859.831,2.347,2.347,0,0,0,2.229-1.4h3.615a5.471,5.471,0,0,1-1.989,3.281,5.981,5.981,0,0,1-3.8,1.209,6.284,6.284,0,0,1-3.152-.78,5.369,5.369,0,0,1-2.114-2.176,7.177,7.177,0,0,1,0-6.375Z",
    transform: "translate(-831.406 -581.212)",
    fill: "#fd3468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9245",
    "data-name": "Path 9245",
    d: "M889.552,592.922v1.328a2.936,2.936,0,0,0-1.114-1.057,3.454,3.454,0,0,0-1.713-.4,3.745,3.745,0,0,0-2.084.6,4.037,4.037,0,0,0-1.471,1.713,5.774,5.774,0,0,0-.542,2.613,5.858,5.858,0,0,0,.542,2.613,4.038,4.038,0,0,0,1.471,1.713,3.748,3.748,0,0,0,2.084.6,3.6,3.6,0,0,0,1.7-.385,3.019,3.019,0,0,0,1.129-1.071v1.342h0a3.355,3.355,0,0,0,3.355-3.355h0v-6.253Zm-.514,6.268a1.709,1.709,0,0,1-2.416.055c-.023-.022-.046-.045-.068-.069a2.393,2.393,0,0,1,0-2.927,1.659,1.659,0,0,1,1.242-.528,1.621,1.621,0,0,1,1.242.542,1.969,1.969,0,0,1,.514,1.455,2.027,2.027,0,0,1-.515,1.472Z",
    transform: "translate(-869.774 -588.564)",
    fill: "#fd3468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9246",
    "data-name": "Path 9246",
    d: "M934.592,581.07v9.319a3.358,3.358,0,0,1-3.359,3.358h0v-9.319a3.359,3.359,0,0,1,3.359-3.358Z",
    transform: "translate(-906.185 -579.783)",
    fill: "#fd3468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9247",
    "data-name": "Path 9247",
    d: "M952.521,602.071a4.424,4.424,0,0,1-1.79-1.715,5.086,5.086,0,0,1-.651-2.621,5.015,5.015,0,0,1,.66-2.6,4.471,4.471,0,0,1,1.8-1.715,5.855,5.855,0,0,1,5.157,0,4.486,4.486,0,0,1,1.8,1.715,5.485,5.485,0,0,1,0,5.215,4.452,4.452,0,0,1-1.807,1.723,5.512,5.512,0,0,1-2.589.6A5.45,5.45,0,0,1,952.521,602.071Zm3.752-2.835a2.175,2.175,0,0,0,.471-1.5,2.141,2.141,0,0,0-.471-1.491,1.511,1.511,0,0,0-1.156-.513,1.488,1.488,0,0,0-1.149.513,2.167,2.167,0,0,0-.461,1.491,2.248,2.248,0,0,0,.445,1.509,1.451,1.451,0,0,0,1.146.513,1.516,1.516,0,0,0,1.176-.523Z",
    transform: "translate(-920.303 -588.584)",
    fill: "#fd3468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9248",
    "data-name": "Path 9248",
    d: "M1000.425,593.426a3.333,3.333,0,0,1,1.731-.48v3.581h-.942a2.553,2.553,0,0,0-1.627.43,1.82,1.82,0,0,0-.531,1.49v.838a3.358,3.358,0,0,1-3.359,3.358h0v-6.252a3.359,3.359,0,0,1,3.359-3.358h0v1.7A4.356,4.356,0,0,1,1000.425,593.426Z",
    transform: "translate(-954.474 -588.679)",
    fill: "#fd3468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9249",
    "data-name": "Path 9249",
    d: "M1025.66,578.913a1.579,1.579,0,0,1-.54-1.225,1.632,1.632,0,0,1,.54-1.251,2.028,2.028,0,0,1,1.43-.5,2.007,2.007,0,0,1,1.413.5,1.634,1.634,0,0,1,.538,1.251,1.58,1.58,0,0,1-.538,1.225,2.029,2.029,0,0,1-1.413.49A2.052,2.052,0,0,1,1025.66,578.913Zm3.093,1.382v6.252a3.356,3.356,0,0,1-3.355,3.356h0V583.65a3.356,3.356,0,0,1,3.356-3.357h0Z",
    transform: "translate(-976.516 -575.939)",
    fill: "#fd3468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9250",
    "data-name": "Path 9250",
    d: "M1052.143,598.419h-3.757a1.776,1.776,0,0,0,.437,1.175,1.34,1.34,0,0,0,.985.385,1.324,1.324,0,0,0,.72-.188,2.878,2.878,0,0,1,1.508-.567h2.553a4.189,4.189,0,0,1-.865,1.775,4.457,4.457,0,0,1-1.619,1.224,5.14,5.14,0,0,1-2.158.445,5.2,5.2,0,0,1-2.526-.6,4.308,4.308,0,0,1-1.731-1.715,5.826,5.826,0,0,1-.009-5.234,4.284,4.284,0,0,1,1.722-1.7,5.728,5.728,0,0,1,5.063-.017,4.2,4.2,0,0,1,1.713,1.672l.04.072A2.275,2.275,0,0,1,1052.143,598.419Zm-.775-1.628a1.2,1.2,0,0,0-.411-.967,1.686,1.686,0,0,0-2.039-.019,1.634,1.634,0,0,0-.514.985Z",
    transform: "translate(-991.455 -588.584)",
    fill: "#fd3468"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9252",
    "data-name": "Path 9252",
    d: "M902.26,648.18a1.579,1.579,0,0,1-.54-1.225,1.63,1.63,0,0,1,.54-1.251,2.028,2.028,0,0,1,1.43-.5,2,2,0,0,1,1.412.5,1.632,1.632,0,0,1,.54,1.251,1.579,1.579,0,0,1-.539,1.225,2.027,2.027,0,0,1-1.412.49A2.051,2.051,0,0,1,902.26,648.18Zm3.092,1.38v6.253a3.359,3.359,0,0,1-3.359,3.357h0v-6.251a3.358,3.358,0,0,1,3.358-3.359Z",
    transform: "translate(-1307.528 5165.91)",
    fill: "#fe6289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9253",
    "data-name": "Path 9253",
    d: "M932.765,663.307a4.355,4.355,0,0,1,.979,2.991v5.6h-3.358v-5.156a1.858,1.858,0,0,0-.428-1.295,1.482,1.482,0,0,0-1.148-.471,1.518,1.518,0,0,0-1.182.471,1.855,1.855,0,0,0-.428,1.295V671.9h0a3.358,3.358,0,0,1-3.358-3.358v-2.894a3.358,3.358,0,0,1,3.358-3.358h0v1.371a3.289,3.289,0,0,1,1.2-1.054,3.615,3.615,0,0,1,1.731-.4A3.342,3.342,0,0,1,932.765,663.307Z",
    transform: "translate(-1324.099 5153.181)",
    fill: "#fe6289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9254",
    "data-name": "Path 9254",
    d: "M969.033,655.6a4.092,4.092,0,0,1,1.482-1.715,3.823,3.823,0,0,1,2.09-.6,3.462,3.462,0,0,1,1.653.385,2.888,2.888,0,0,1,1.139,1.052v-1.009a3.376,3.376,0,0,1,3.375-3.375h0v12.677H975.4v-1.336a2.856,2.856,0,0,1-1.113,1.063,3.477,3.477,0,0,1-1.7.393,3.767,3.767,0,0,1-2.083-.6,4.1,4.1,0,0,1-1.474-1.723,6.569,6.569,0,0,1,0-5.215Zm5.877,1.146a1.737,1.737,0,0,0-2.455-.044l-.037.037a2.033,2.033,0,0,0-.5,1.463,2.073,2.073,0,0,0,.5,1.465,1.629,1.629,0,0,0,1.251.541,1.648,1.648,0,0,0,1.242-.531,2.055,2.055,0,0,0,.505-1.475A2.026,2.026,0,0,0,974.909,656.743Z",
    transform: "translate(-1357.547 5162.066)",
    fill: "#fe6289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9255",
    "data-name": "Path 9255",
    d: "M1022.005,667.685h-3.756a1.771,1.771,0,0,0,.437,1.175,1.34,1.34,0,0,0,.987.385,1.324,1.324,0,0,0,.718-.188,2.88,2.88,0,0,1,1.508-.567h2.553a4.175,4.175,0,0,1-.865,1.775,4.46,4.46,0,0,1-1.619,1.224,5.145,5.145,0,0,1-2.158.445,5.205,5.205,0,0,1-2.526-.6,4.306,4.306,0,0,1-1.731-1.715,5.824,5.824,0,0,1-.008-5.234,4.281,4.281,0,0,1,1.722-1.7,5.728,5.728,0,0,1,5.063-.017,4.2,4.2,0,0,1,1.713,1.672l.04.072A2.275,2.275,0,0,1,1022.005,667.685Zm-.775-1.628a1.2,1.2,0,0,0-.411-.966,1.683,1.683,0,0,0-2.037-.019,1.625,1.625,0,0,0-.515.985Z",
    transform: "translate(-1392.33 5153.266)",
    fill: "#fe6289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9256",
    "data-name": "Path 9256",
    d: "M1063.907,662.692a3.338,3.338,0,0,1,1.731-.48v3.581h-.942a2.554,2.554,0,0,0-1.628.43,1.822,1.822,0,0,0-.531,1.491v.838a3.358,3.358,0,0,1-3.358,3.358h0v-6.252a3.358,3.358,0,0,1,3.358-3.358h0V664A4.366,4.366,0,0,1,1063.907,662.692Z",
    transform: "translate(-1425.48 5153.17)",
    fill: "#fe6289"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4144",
    "data-name": "Group 4144",
    transform: "translate(-416.735 5811.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10715",
    "data-name": "Path 10715",
    d: "M858.171,662.216V650.888a2.845,2.845,0,0,1,2.845-2.845h6.443a2.07,2.07,0,0,1-2.071,2.071h-2.1a2.569,2.569,0,0,0-2.569,2.568v1.292h6.333a2.071,2.071,0,0,1-2.071,2.071h-4.262v3.619a2.553,2.553,0,0,1-2.553,2.553Z",
    transform: "translate(-858.171 -648.043)",
    fill: "#fe6289"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f5d240e6ba569b0d6ea1c63106737aa5.svg";
export { ForwardRef as ReactComponent };